module.exports = __webpack_public_path__ + "static/media/game_cover_punball.3d86304d.png";